import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import utilSelector from "../../redux/selectors/util.selector";
import OtpGeneration from "./OtpGeneration";
import OTPForm from "./OtpForm";
import "./account.scss";
import { useHistory } from "react-router";
import AccountActions from "../../redux/actions/account.actions";
import customerSelector from "../../redux/selectors/customer.selector";
import actionTypes from "../../redux/action-types";

const CheckCircleFilled = ({ size = 64, className = "" }) => (
  // Filled style for success (simulated Ant Design CheckCircleFilled)
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
  </svg>
);

const DEFAULT_COUNTRY_CODE = "91";
const OtpLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = history.location;
  const isCheckoutPage = pathname.includes("checkout");
  const [step, setStep] = useState("mobile"); // 'mobile', 'otp', 'success'
  const [mobileNumber, setMobileNumber] = useState("");
  const [countryCode, setCountryCode] = useState();
  const [message, setMessage] = useState("");
  const isOtpModalVisible = useSelector(utilSelector.isOtpModalVisible);
  const isOtpBeingSent = useSelector(customerSelector.isOtpBeingSent);
  const isOtpSent = useSelector(customerSelector.isOtpSent);
  const isOtpBeingVerified = useSelector(customerSelector.isOtpBeingVerified);
  const isOtpVerified = useSelector(customerSelector.isOtpVerified);

  useEffect(() => {
    if (isOtpModalVisible) {
      setStep("mobile");
      setMobileNumber("");
      setCountryCode(DEFAULT_COUNTRY_CODE);
      setMessage("Please enter your mobile number to begin.");
    } else {
      setStep("mobile");
      setMobileNumber("");
      setCountryCode(DEFAULT_COUNTRY_CODE);
      setMessage("");
    }
  }, [isOtpModalVisible]);

  useEffect(() => {
    if (isOtpSent) {
      setStep("otp");
      setMessage(
        `OTP sent to +${countryCode}${mobileNumber}. Please check your phone.`,
      );
    }
  }, [isOtpSent]);

  useEffect(() => {
    handleCloseModal();
  }, [isOtpVerified]);

  const handleCloseModal = () => {
    dispatch({
      type: "SHOW_OTP_LOGIN_MODAL",
      payload: false,
    });
    dispatch({
      type: actionTypes.IS_OTP_SENT,
      payload: false,
    });
  };

  const handleSendOtp = (number, selectedCountry) => {
    setMobileNumber(number);
    setCountryCode(selectedCountry);
    dispatch(
      AccountActions.generateOtpAction({
        mobile: `${number}`,
        code: `+${selectedCountry}`,
      }),
    );
  };

  const handleVerify = (otp) => {
    dispatch(
      AccountActions.verifyOtpAction({
        mobile: `${mobileNumber}`,
        code: `+${countryCode}`,
        otp,
      }),
    );
  };

  const handleChangeNumber = () => {
    setStep("mobile");
    setMessage("Please enter your mobile number to begin.");
    dispatch({
      type: actionTypes.IS_OTP_SENT,
      payload: false,
    });
    // Keep mobile number intact so user doesn't have to re-type it
  };

  const renderContent = () => {
    switch (step) {
      case "mobile":
        return (
          <>
            <div className="card-header">
              <h1 className="title-extra-large">Login</h1>
              <p className="subtitle-small">
                {message || "Please enter your mobile number to begin."}
              </p>
            </div>
            <OtpGeneration
              mobileNumber={mobileNumber}
              setMobileNumber={setMobileNumber}
              country={countryCode}
              setCountry={setCountryCode}
              onSendOtp={handleSendOtp}
              isSending={isOtpBeingSent}
            />
          </>
        );
      case "otp":
        return (
          <OTPForm
            mobileNumber={mobileNumber}
            countryCode={countryCode}
            onVerify={handleVerify}
            onChangeNumber={handleChangeNumber}
            isSending={isOtpBeingSent}
            onSendOtp={handleSendOtp}
            isOtpBeingVerified={isOtpBeingVerified}
          />
        );
      case "success":
        return (
          <div className="success-screen">
            {/* Using Ant Design name: CheckCircleFilled, adjusted size via prop */}
            <CheckCircleFilled size={64} className="success-icon" />
            <h2 className="title-large">Success!</h2>
            <p className="success-text">
              Your mobile number +{mobileNumber} has been verified.
            </p>
            <button
              onClick={handleCloseModal}
              className="btn btn-lg btn-primary start-over-btn"
            >
              Close and Continue
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  const goToHomepage = () => {
    handleCloseModal();
    history.push("/");
  };

  const guestCheckout = () => {
    dispatch({
      type: "UPDATE_GUEST_FLOW",
      payload: true,
    });
  };

  return (
    <div className="otp-login-container">
      {/* Modal Overlay and Content */}
      {isOtpModalVisible && (
        <div className="modal-overlay">
          <div className="verification-card modal-content">
            {!isCheckoutPage && (
              <button onClick={handleCloseModal} className="modal-close-btn">
                &times;
              </button>
            )}

            <div className="">
              {renderContent()}
              {isCheckoutPage && (
                <>
                  <div className="card-header">
                    {/* <a className="subtitle-small" onClick={goToHomepage}>
                      {"Go to Homepage"}
                    </a> */}
                    <a className="subtitle-small" onClick={guestCheckout}>
                      {"Continue as Guest"}
                    </a>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OtpLogin;
